import { Component, OnInit } from '@angular/core';
import { DwActionConfigBaseComponent } from '@devwareapps/devware-cap';
import { AppMetaDataLookups, CheckRideRequestPaymentPartyAllItems } from '../../../../../../meta-data/app-meta-data.service';

@Component({
  selector: 'app-add-payment-method-action-config',
  template: `
     <div dwRow *ngIf="actionConfigFG" [formGroup]="actionConfigFG">
        <div dwCol="12">
          <label>Owner Payment Party</label>
          <dw-search-select-lookup formControlName="paymentPartyId" [lookupId]="partyTypeLookupId"
            showBlankOption="false"></dw-search-select-lookup>
        </div>
     </div>
  `
})
export class AddPaymentMethodActionConfigComponent extends DwActionConfigBaseComponent {

  partyTypeLookupId = AppMetaDataLookups.CheckRideRequestPaymentPartyAllItems;
  
  protected addControls() {
    this.addControl('paymentPartyId', null, CheckRideRequestPaymentPartyAllItems.PilotExaminer);
  }

}
